module.exports = __webpack_public_path__ + "img/man-border-green.14ce4a86.svg";